module.exports = __webpack_public_path__ + "static/peg-tighten-50d919e1f2fb207cb5ea9dd982fdf50c.gif";